export default __webpack_public_path__ + "static/protocol-mobile-de06461c6c11357a6333818970836a4b.png";